module.exports = __webpack_public_path__ + "static/img/04.ca3e092.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotkeSlider/04.jpg
// module id = iBLp
// module chunks = 0